import { VC } from "vidyoclient-nativewebrtc-sdk";

import { createChatLifecycle } from "@/features/chat/api/chat-lifecycle";
import { createParticipantsLifecycle } from "@/features/participants/api/participants-lifecycle";
import { createRecordingsLifecycle } from "@/features/recordings/api/recordings-lifecycle";

import { createLocalDeviceLifecycle } from "../../vidyo-devices/utils/local-devices-lifecycle";
import { VidyoConnector } from "../types/vidyoclient-nativewebrtc-sdk";

export const connectToVidyo = async () => {
  try {
    const conn = await VC.CreateVidyoConnector({
      remoteParticipants: 25,
      viewId: null,
      viewStyle: "VIDYO_CONNECTORVIEWSTYLE_Default", // Not used in custom layout
      logFileName: "",
      logFileFilter: "",
      userData: 0,
    });

    const v = await conn.GetVersion();
    await initConnector(conn);
    console.info(`Launching VidyoSDK for web version: ${v}`);

    return conn;
  } catch (e) {
    console.error(e);
  }
};

async function initConnector(vidyoConnector: VidyoConnector) {
  const lifecycles = [
    createLocalDeviceLifecycle(vidyoConnector),
    createParticipantsLifecycle(vidyoConnector),
    createChatLifecycle(vidyoConnector),
    createRecordingsLifecycle(vidyoConnector),
  ];

  await Promise.all(lifecycles);
}
